import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary

function SyllabusCommitteTab() {
  return (
    <>
      <div className="service-title font-700 mb-3">
        SEAFARER{" "}
        <span className="text-orange-ef3e33 font-400">
          {" "}
          SYLLABUS COMMITTEE{" "}
        </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-5">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg2} className="img-fluid rounded-1" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <p className="font-18 mb-4">
            Regulation 9 of the Merchant Shipping (Training, Certification and
            Safe Manning) Regulations, 2021 (the Regulations) requires that
            SAMSA shall establish the Syllabus Committee. The Syllabus
            Committee's primary functions are to:
          </p>

          <ul className="trust">
              <li>keep the​ Training Standards Code​​ under review.</li>
              <li>Advise the Authority on matters relate​ed to Training, Assessment and Certification of Seafarers.</li>
              
          </ul>

          <p className="font-18 mb-4">Accordingly, the Chief Examiner established the Syllabus Committee to comprise of (not limited to) the following members:</p>

          <ul className="trust">
              <li>Senior Examiners – Deck, Engine and Radio, appointed in accordance with Regulation 5</li>
              <li>The Registrar and the Deputy Registrar of Seafarers, appointed in accordance with Regulation 4</li>
              <li>Nominated SAMSA Representatives x 3 (Fishing specialist, Quality Assurance Manager, Secretary)</li>
              <li>Representative of SAIMI</li>
              <li>
                  Seafarer Employers:
                  <ul className="star-li">
                      <li>Four representatives for the Fishing Industry (nominated from the National Fishing Forum)</li>
                      <li>Two other employers</li>
                  </ul>

              </li>

              <li>Representatives from SAIMENA and SOMMSA x 2 each</li>
              <li>
                  Training organisations:
                  <ul className="star-li">
                      <li>1 representative per training  organisation accredited to provide academic courses required for  officers (currently 6 organisations)</li>
                      <li>Short course accredited institutions with more than 12 accreditations</li>
                  </ul>

              </li>

              <li>
                  Additional persons may be invited by the chairperson - on request:
                  <ul className="star-li">
                      <li>Persons requesting attendance shall do so at least a week before the meeting via secretary.</li>
                      <li>The invitation will apply per meeting.</li>
                      <li>For certain meetings, the Chairperson may send an open invite to members of the industry at their discretion.</li>
                  </ul>

              </li>
          </ul>
          
        </div>
        <div className="col-12">
          <div className="bg-gray-de p-4 rounded">
            <p className="mb-3">
              The work of the Syllabus Committee shall be in accordance with the
              Quality Standards System established in accordance with Regulation
              6.
            </p>
            <p>
              In May 2018 the Syllabus Committee approved the process for
              approval of the SAMSA Code (POP 502 - Approval of the SAMSA Code
              by the Syllabus Committee). The SAMSA Code is now known as the
              Training Standards Code, and the process for approval is
              QMS-OP-1004 - Approval of the Training Standards Code. Members of
              the Syllabus Committee may access the process below:
            </p>
          </div>
          <div class="row g-3 g-sm-4 mt-2">
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <div class="focus-block bg-green-38B652 rounded-2 w-100">
                <div class="icon">
                  <i class="educate-icon"></i>
                </div>
                <p>Approval of the Training Standards Code</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <div class="focus-block bg-primary-green rounded-2 w-100">
                <div class="icon">
                  <i class="multi-user-icon"></i>
                </div>
                <p>Criteria for assessing Training Standards</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <div class="focus-block bg-orange-ee8029 rounded-2 w-100">
                <div class="icon">
                  <i class="shop-icon"></i>
                </div>
                <p>List of Training Standards</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <div class="focus-block bg-green-38B652 rounded-2 w-100">
                <div class="icon">
                  <i class="multi-user-icon"></i>
                </div>
                <p>Format of the Standards of Training and Assessment​</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SyllabusCommitteTab;